import api from '../lib/api';

const companyService = {
    getCompany: async () => {
        try {
            const response = await api.get('/company');
            return response.data;
        } catch (error) {
            console.error('Error fetching company:', error);
            throw error;
        }
    },

    getAllCompanies: async (params = {}) => {
        try {
            const response = await api.get('/admin/companies', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching companies:', error);
            throw error;
        }
    },

    updateCompany: async (companyData) => {
        try {
            // Create FormData for file uploads
            const formData = new FormData();
            
            console.log('Building FormData from:', companyData);
            
            // Add all text fields - include all fields even if empty
            Object.keys(companyData).forEach(key => {
                if (key === 'company_logo' || key === 'banner_image') {
                    // Handle file uploads separately
                    if (companyData[key] instanceof File) {
                        console.log(`Adding file: ${key}`);
                        formData.append(key, companyData[key]);
                    }
                } else if (key === 'social_media_links') {
                    // Handle array - send each item with brackets for Laravel to recognize as array
                    if (companyData[key] && Array.isArray(companyData[key]) && companyData[key].length > 0) {
                        companyData[key].forEach((link) => {
                            if (link && link.trim() !== '') {
                                formData.append('social_media_links[]', link.trim());
                            }
                        });
                    }
                    // If array is empty or doesn't exist, don't send it - Laravel will handle it
                } else {
                    // Include all values, even empty strings - let backend decide what to do
                    const value = companyData[key];
                    if (value !== null && value !== undefined) {
                        console.log(`Adding field: ${key} = ${value}`);
                        formData.append(key, value === '' ? '' : value);
                    }
                }
            });
            
            // Log FormData contents
            console.log('FormData entries:');
            for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + (pair[1] instanceof File ? '[File]' : pair[1]));
            }

            const response = await api.post('/company', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error updating company:', error);
            console.error('Error response:', error.response);
            console.error('Error data:', error.response?.data);
            throw error;
        }
    },

    deleteCompanyLogo: async () => {
        try {
            const formData = new FormData();
            formData.append('delete_company_logo', '1');
            
            const response = await api.post('/company', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting company logo:', error);
            throw error;
        }
    },

    deleteBannerImage: async () => {
        try {
            const formData = new FormData();
            formData.append('delete_banner_image', '1');
            
            const response = await api.post('/company', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting banner image:', error);
            throw error;
        }
    },
};

export default companyService;

